/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EVehicleDriverPanelTabs, Position, IMapContextMenuData, MarkerInfo, IScrollItem } from '../../models';

export interface IVehicleDriverPanelState {
  isCollapsed: boolean;
  activeTab: EVehicleDriverPanelTabs;
  overlayMargins: Position;
  contextMenu: IMapContextMenuData<MarkerInfo>;
  itemToScrollTo?: IScrollItem;
}

export const initialVehicleDriverPanelState: IVehicleDriverPanelState = {
  isCollapsed: false,
  activeTab: EVehicleDriverPanelTabs.VehicleStatus,
  overlayMargins: null,
  contextMenu: null,
  itemToScrollTo: null
};
